import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=0feeb543&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=0feeb543&prod&scoped=true&lang=css"
import style1 from "./Documents.vue?vue&type=style&index=1&id=0feeb543&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feeb543",
  null
  
)

export default component.exports